module.exports = __webpack_public_path__ + "static/img/referesh.f5536241.png";